// extracted by mini-css-extract-plugin
export default {"MapStubContainer":"MapStub_MapStubContainer__yVTlB"};